"use strict";
module.exports = validate20;
module.exports.default = validate20;
var schema22 = { "$schema": "http://json-schema.org/draft-07/schema#", "additionalProperties": false, "definitions": { "GroupByOptions": { "additionalProperties": false, "properties": { "attribute": { "type": "string" }, "size": { "type": "number" }, "values": { "items": { "type": "string" }, "type": "array" } }, "required": ["attribute", "size", "values"], "type": "object" }, "SortOptions": { "additionalProperties": false, "properties": { "attribute": { "description": "Attribute to sort by", "type": "string" }, "order": { "description": "Order of the sort.\nMust be either \"asc\" or \"desc\"", "type": "string" } }, "required": ["attribute", "order"], "type": "object" } }, "properties": { "customResponseMask": { "description": "Response mask to return only specific attributes of items", "type": "string" }, "filter": { "description": "Filter string", "type": "string" }, "groupBy": { "$ref": "#/definitions/GroupByOptions", "description": "Select which attribute & values for grouping the results.\nIf specified, this will add a `groups` list in the response, alongside the regular `items` list" }, "sortBy": { "description": "List of sorting rules\n(applied in order)", "items": { "$ref": "#/definitions/SortOptions" }, "type": "array" } }, "type": "object" };
var schema23 = { "additionalProperties": false, "properties": { "attribute": { "type": "string" }, "size": { "type": "number" }, "values": { "items": { "type": "string" }, "type": "array" } }, "required": ["attribute", "size", "values"], "type": "object" };
var schema24 = { "additionalProperties": false, "properties": { "attribute": { "description": "Attribute to sort by", "type": "string" }, "order": { "description": "Order of the sort.\nMust be either \"asc\" or \"desc\"", "type": "string" } }, "required": ["attribute", "order"], "type": "object" };
function validate20(data, valCxt) {
    "use strict";
    ;
    if (valCxt) {
        var instancePath = valCxt.instancePath;
        var parentData = valCxt.parentData;
        var parentDataProperty = valCxt.parentDataProperty;
        var rootData = valCxt.rootData;
    }
    else {
        var instancePath = "";
        var parentData = undefined;
        var parentDataProperty = undefined;
        var rootData = data;
    }
    var vErrors = null;
    var errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for (var key0 in data) {
            if (!((((key0 === "customResponseMask") || (key0 === "filter")) || (key0 === "groupBy")) || (key0 === "sortBy"))) {
                var err0 = { instancePath: instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema22, data: data };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
        if (data.customResponseMask !== undefined) {
            var data0 = data.customResponseMask;
            if (typeof data0 !== "string") {
                var err1 = { instancePath: instancePath + "/customResponseMask", schemaPath: "#/properties/customResponseMask/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.customResponseMask.type, parentSchema: schema22.properties.customResponseMask, data: data0 };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        if (data.filter !== undefined) {
            var data1 = data.filter;
            if (typeof data1 !== "string") {
                var err2 = { instancePath: instancePath + "/filter", schemaPath: "#/properties/filter/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.filter.type, parentSchema: schema22.properties.filter, data: data1 };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
        if (data.groupBy !== undefined) {
            var data2 = data.groupBy;
            if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                if (data2.attribute === undefined) {
                    var err3 = { instancePath: instancePath + "/groupBy", schemaPath: "#/definitions/GroupByOptions/required", keyword: "required", params: { missingProperty: "attribute" }, message: "must have required property '" + "attribute" + "'", schema: schema23.required, parentSchema: schema23, data: data2 };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
                if (data2.size === undefined) {
                    var err4 = { instancePath: instancePath + "/groupBy", schemaPath: "#/definitions/GroupByOptions/required", keyword: "required", params: { missingProperty: "size" }, message: "must have required property '" + "size" + "'", schema: schema23.required, parentSchema: schema23, data: data2 };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
                if (data2.values === undefined) {
                    var err5 = { instancePath: instancePath + "/groupBy", schemaPath: "#/definitions/GroupByOptions/required", keyword: "required", params: { missingProperty: "values" }, message: "must have required property '" + "values" + "'", schema: schema23.required, parentSchema: schema23, data: data2 };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                for (var key1 in data2) {
                    if (!(((key1 === "attribute") || (key1 === "size")) || (key1 === "values"))) {
                        var err6 = { instancePath: instancePath + "/groupBy", schemaPath: "#/definitions/GroupByOptions/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties", schema: false, parentSchema: schema23, data: data2 };
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                    }
                }
                if (data2.attribute !== undefined) {
                    var data3 = data2.attribute;
                    if (typeof data3 !== "string") {
                        var err7 = { instancePath: instancePath + "/groupBy/attribute", schemaPath: "#/definitions/GroupByOptions/properties/attribute/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema23.properties.attribute.type, parentSchema: schema23.properties.attribute, data: data3 };
                        if (vErrors === null) {
                            vErrors = [err7];
                        }
                        else {
                            vErrors.push(err7);
                        }
                        errors++;
                    }
                }
                if (data2.size !== undefined) {
                    var data4 = data2.size;
                    if (!((typeof data4 == "number") && (isFinite(data4)))) {
                        var err8 = { instancePath: instancePath + "/groupBy/size", schemaPath: "#/definitions/GroupByOptions/properties/size/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema23.properties.size.type, parentSchema: schema23.properties.size, data: data4 };
                        if (vErrors === null) {
                            vErrors = [err8];
                        }
                        else {
                            vErrors.push(err8);
                        }
                        errors++;
                    }
                }
                if (data2.values !== undefined) {
                    var data5 = data2.values;
                    if (Array.isArray(data5)) {
                        var len0 = data5.length;
                        for (var i0 = 0; i0 < len0; i0++) {
                            var data6 = data5[i0];
                            if (typeof data6 !== "string") {
                                var err9 = { instancePath: instancePath + "/groupBy/values/" + i0, schemaPath: "#/definitions/GroupByOptions/properties/values/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema23.properties.values.items.type, parentSchema: schema23.properties.values.items, data: data6 };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        var err10 = { instancePath: instancePath + "/groupBy/values", schemaPath: "#/definitions/GroupByOptions/properties/values/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema23.properties.values.type, parentSchema: schema23.properties.values, data: data5 };
                        if (vErrors === null) {
                            vErrors = [err10];
                        }
                        else {
                            vErrors.push(err10);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err11 = { instancePath: instancePath + "/groupBy", schemaPath: "#/definitions/GroupByOptions/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema23.type, parentSchema: schema23, data: data2 };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
        }
        if (data.sortBy !== undefined) {
            var data7 = data.sortBy;
            if (Array.isArray(data7)) {
                var len1 = data7.length;
                for (var i1 = 0; i1 < len1; i1++) {
                    var data8 = data7[i1];
                    if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                        if (data8.attribute === undefined) {
                            var err12 = { instancePath: instancePath + "/sortBy/" + i1, schemaPath: "#/definitions/SortOptions/required", keyword: "required", params: { missingProperty: "attribute" }, message: "must have required property '" + "attribute" + "'", schema: schema24.required, parentSchema: schema24, data: data8 };
                            if (vErrors === null) {
                                vErrors = [err12];
                            }
                            else {
                                vErrors.push(err12);
                            }
                            errors++;
                        }
                        if (data8.order === undefined) {
                            var err13 = { instancePath: instancePath + "/sortBy/" + i1, schemaPath: "#/definitions/SortOptions/required", keyword: "required", params: { missingProperty: "order" }, message: "must have required property '" + "order" + "'", schema: schema24.required, parentSchema: schema24, data: data8 };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                        for (var key2 in data8) {
                            if (!((key2 === "attribute") || (key2 === "order"))) {
                                var err14 = { instancePath: instancePath + "/sortBy/" + i1, schemaPath: "#/definitions/SortOptions/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties", schema: false, parentSchema: schema24, data: data8 };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                            }
                        }
                        if (data8.attribute !== undefined) {
                            var data9 = data8.attribute;
                            if (typeof data9 !== "string") {
                                var err15 = { instancePath: instancePath + "/sortBy/" + i1 + "/attribute", schemaPath: "#/definitions/SortOptions/properties/attribute/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema24.properties.attribute.type, parentSchema: schema24.properties.attribute, data: data9 };
                                if (vErrors === null) {
                                    vErrors = [err15];
                                }
                                else {
                                    vErrors.push(err15);
                                }
                                errors++;
                            }
                        }
                        if (data8.order !== undefined) {
                            var data10 = data8.order;
                            if (typeof data10 !== "string") {
                                var err16 = { instancePath: instancePath + "/sortBy/" + i1 + "/order", schemaPath: "#/definitions/SortOptions/properties/order/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema24.properties.order.type, parentSchema: schema24.properties.order, data: data10 };
                                if (vErrors === null) {
                                    vErrors = [err16];
                                }
                                else {
                                    vErrors.push(err16);
                                }
                                errors++;
                            }
                        }
                    }
                    else {
                        var err17 = { instancePath: instancePath + "/sortBy/" + i1, schemaPath: "#/definitions/SortOptions/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema24.type, parentSchema: schema24, data: data8 };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                }
            }
            else {
                var err18 = { instancePath: instancePath + "/sortBy", schemaPath: "#/properties/sortBy/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema22.properties.sortBy.type, parentSchema: schema22.properties.sortBy, data: data7 };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
        }
    }
    else {
        var err19 = { instancePath: instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.type, parentSchema: schema22, data: data };
        if (vErrors === null) {
            vErrors = [err19];
        }
        else {
            vErrors.push(err19);
        }
        errors++;
    }
    validate20.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validateSearchGroupOptionsSchema.js.map